(function($) {
    $.widget("ca.caScheduleGrid", {
        options: {
            name : 'caScheduleGrid',
            startTime : new Date('00:00:00'),
            endTime : new Date('23:59:59'),
            timeInterval : 15,
            rowHeight : 20,
            columnWidth : 100,

            selectable : false,
            multiColumnSelectable : false,
            multiBlockSelectable : true,

            columnsData : {},
            workTime : {},
            selectedTime : {},

            columnIndexes : {},
            columnIds : {},

            onChangeTimeFunction : function() {},
            onChangeTimeThis : this,

            hScroll: null
        },
        _create : function() {
            var self = this;
            var options = this.options;

            var i = 0;
            for (var columnId in options.columnsData) {
                options.columnIndexes[columnId] = i;
                options.columnIds[i] = columnId;
                i++;
            }

            if (options.selectable) {
                self.enableSelectable();
            }

            self.options.hScroll = new IScroll(
                this.element.find('.blocks-table').get(0), 
                {
                    scrollX: true
                }
            );
    
            jQuery(document).off('mouseup.scheduleGrid');
            jQuery(document).on('mouseup.scheduleGrid', function(e) {
                self.options.hScroll._end(e);
            });
            
            self.onScrolling = function() {};
            self.options.hScroll.on('scrollStart', function(e) {
                self.options.scrolling = false;
                self.onScrolling = function(i) {
                    i = i !== undefined ? i : 0;
                    if (i > 200) {
                        return false;
                    }
                    if (self.options.hScroll.x !== self.options.lastScrollX) {
                        self.options.scrolling = true;
                    } else {
                        setTimeout(function() {
                            self.onScrolling(++i);
                        }, 30);
                    }
                };
                self.options.lastScrollX = self.options.hScroll.x;
                self.onScrolling();
            });
            self.options.hScroll.on('scrollEnd', function(e) {
                self.onScrolling = function() {};
            });
           
        },

        getColumnIndexById : function(columnId) {
            return this.options.columnIndexes[columnId];
        },

        getColumnIdByIndex : function(columnIndex) {
            return this.options.columnIds[columnIndex];
        },

        getOffsetByTimeIndex : function(timeIndex) {
            return timeIndex * this.options.rowHeight;
        },

        getTimeIndexByOffset : function(offset) {
            return offset / this.options.rowHeight;
        },

        _updateSelectableTime : function() {
            var self = this;
            var selectableTable = self.element.find('.selectable-table');

            var columnIndex = 0;
            $.each(selectableTable.find('.column > div'), function(columnKey, column) {
                var $column = $(column);
                var workTime = self.options.workTime[self.getColumnIdByIndex(columnIndex)];
                var cellIndex = 0;
                $.each($column.find('> .cell'), function(cellKey, cell) {
                    if (workTime[cellIndex]) {
                        $(cell).addClass('free-time');
                    } else {
                        $(cell).removeClass('free-time');
                    }
                    cellIndex++;
                });
                columnIndex++;
            });
        },

        clearSelectedTime : function() {
            this.element.find('.selectable-table .selected-block').remove();

            for (var columnId in this.options.selectedTime) {
                for (var rowIndex in this.options.selectedTime[columnId]) {
                    this.options.selectedTime[columnId][rowIndex] = false;
                }
            }
        },

        _showSelectedTime : function() {
            var self = this;
            self.element.find('.selectable-table .selected-block').remove();

            var startRowIndex, endRowIndex;
            for (var columnId in self.options.selectedTime) {
                for (var rowIndex in self.options.selectedTime[columnId]) {
                    if (self.options.selectedTime[columnId][rowIndex] == true) {
                        if (startRowIndex == null) {
                            startRowIndex = rowIndex;
                        }
                        endRowIndex = rowIndex;
                    } else if (startRowIndex != null && endRowIndex != null) {
                        self._showSelectedBlock(self.getColumnIndexById(columnId), startRowIndex, endRowIndex);
                        startRowIndex = null;
                        endRowIndex = null;
                    }
                }
                if (startRowIndex != null && endRowIndex != null) {
                    self._showSelectedBlock(self.getColumnIndexById(columnId), startRowIndex, endRowIndex);
                    startRowIndex = null;
                    endRowIndex = null;
                }
            }
        },

        _showSelectedBlock : function(columnIndex, startRowIndex, endRowIndex) {
            var self = this;
            var options = self.options;

            var column = this.element.find('.selectable-table .column:nth-child('+ (columnIndex + 1) +') > div');

            var selectedBlock = $('<div class="selected-block"><div><a href="#" class="close-selected-block ui-icon ui-icon-close"></a></div></div>');

            selectedBlock.find('a').click(self, function(event) {
                var self = event.data;
                var selectedBlock = $(this).closest('.selected-block');

                var startRowIndex = self.getTimeIndexByOffset(parseInt(selectedBlock.css('top')));
                var endRowIndex = startRowIndex + self.getTimeIndexByOffset(selectedBlock.height());
                var columnIndex = self.getColumnIdByIndex(selectedBlock.closest('.column').index());

                for (var i = startRowIndex; i <= endRowIndex; i++) {
                    options.selectedTime[columnIndex][i] = false;
                }

                selectedBlock.remove();

                if (column.find('.selected-block').size() == 0) {
                    column.closest('.selectable-table').find('.column > div').selectable('enable');
                }

                self._callOnChangeTime();

                return false;
            });

            selectedBlock.css('top', self.getOffsetByTimeIndex(startRowIndex));
            selectedBlock.css('left', 0);
            selectedBlock.height(self.getOffsetByTimeIndex(endRowIndex - startRowIndex + 1));
            selectedBlock.width(column.width());

            selectedBlock.appendTo(column);

            var columnId = self.getColumnIdByIndex(columnIndex);

            selectedBlock.resizable({
                handles : 'n,s',
                grid : options.rowHeight,
                minHeight : options.rowHeight,
                stop : function(event, ui) {
                    var columnHeight = $(this).closest('.column').height();
                    var top = parseInt(ui.element.css('top'));
                    var height = ui.element.height();

                    if (top < 0) {
                        height += top;
                        top = 0;
                    }
                    if (top + height > columnHeight) {
                        height = columnHeight - top;
                    }

                    if (top < ui.originalPosition.top) {
                        var startIndex = self.getTimeIndexByOffset(ui.originalPosition.top);
                        var endIndex = self.getTimeIndexByOffset(top);

                        for (var i = startIndex; i >= endIndex; i--) {
                            if (options.workTime[columnId][i] == false) {
                                break;
                            }
                            options.selectedTime[columnId][i] = true;
                        }
                    } else if (top > ui.originalPosition.top) {
                        var startIndex = self.getTimeIndexByOffset(ui.originalPosition.top);
                        var endIndex = self.getTimeIndexByOffset(top);

                        for (var i = startIndex; i < endIndex; i++) {
                            options.selectedTime[columnId][i] = false;
                        }
                    } else if (height < ui.originalSize.height) {
                        var startIndex = self.getTimeIndexByOffset(top + ui.originalSize.height);
                        var endIndex = self.getTimeIndexByOffset(top + height);

                        for (var i = startIndex; i >= endIndex; i--) {
                            options.selectedTime[columnId][i] = false;
                        }
                    } else if (height > ui.originalSize.height) {
                        var startIndex = self.getTimeIndexByOffset(top + ui.originalSize.height);
                        var endIndex = self.getTimeIndexByOffset(top + height);

                        for (var i = startIndex; i < endIndex; i++) {
                            if (options.workTime[columnId][i] == false) {
                                break;
                            }
                            options.selectedTime[columnId][i] = true;
                        }
                    }

                    self._showSelectedTime();
                    self._callOnChangeTime();
                }
            });
        },

        enableSelectable : function() {
            var self = this;
            var element = self.element;
            var options = self.options;

            var selectableTable = element.find('.selectable-table');
            if (selectableTable.size() === 0) {
                selectableTable = $('<div class="selectable-table"></div>').appendTo(element.find('.blocks-table-inner'));

                var column = $('<div class="column"><div></div></div>');
                var columnInner = column.find('> div');
                var time = new Date(self.options.startTime.getTime());
                while (time < self.options.endTime) {
                    time.setMinutes(time.getMinutes() + self.options.timeInterval);

                    var cell = $('<div class="cell"></div>').appendTo(columnInner);
                    cell.height(self.options.rowHeight);
                }

                $.each(self.options.columnsData, function(k, v) {
                    var selectableColumn = $(column).clone();
                    selectableColumn.width(element.find('#column-'+ k).outerWidth());

                    selectableColumn.appendTo(selectableTable);

                    selectableColumn.find('> div').selectable({
                        filter : '.free-time',
                        cancel : '.selected-block, .disabled-column',
                        start : function(event, ui) {
                            var column = $(this);
                            selectableTable.find('.ui-selected').removeClass('ui-selected');

                            if (!self.options.multiBlockSelectable) {
                                column.find('.close-selected-block').trigger('click');
                            }
                        },
                        stop : function(event, ui) {
                            var column = $(this);
                            if (column.selectable('option', 'disabled')) {
                                return false;
                            }

                            if (!self.options.multiColumnSelectable) {
                                var disabledSelectableColumns = column.closest('.selectable-table').find('.column > div').not(column);
                                disabledSelectableColumns.selectable('disable');
                            }

                            var columnIndex = column.parent().index();

                            $.each(column.find('.ui-selected'), function(k, cell) {
                                cell = $(cell);
                                cell.removeClass('ui-selected');
                                var cellIndex = cell.index();
                                self.options.selectedTime[self.getColumnIdByIndex(columnIndex)][cellIndex] = true;
                            });
                            if (!self.options.scrolling) {
                                self._showSelectedTime();
                                self._callOnChangeTime();
                            }
                            self.options.scrolling = false;
                        }
                    });
                });

                var startTopPosition = 0;
                var endColumn = null;

                selectableTable.find('.column > div').sortable({
                    connectWith : selectableTable.find('.column > div'),
                    grid : [options.columnWidth + 1, options.rowHeight],
                    containment : selectableTable,
                    items : '.selected-block',
                    start : function(event, ui) {
                        startTopPosition = parseInt(ui.helper.css('top'));

                        if (!options.multiColumnSelectable) {
                            var column = $(ui.item).parent();
                            if (column.find('.selected-block').not('.ui-sortable-placeholder').size() == 1) {
                                column.closest('.selectable-table').find('.column > div').selectable('enable');
                            }
                        }
                    },
                    beforeStop : function(event, ui) {
                        endColumn = $(ui.helper).closest('.column');
                    },
                    stop : function(event, ui) {
                        var heightRows = ui.item.height() / options.rowHeight;
                        var startColumn = $(this).closest('.column');

                        var startColumnId = self.getColumnIdByIndex(startColumn.index());
                        var endColumnId = self.getColumnIdByIndex(endColumn.index());

                        var startTopOffset = self.getTimeIndexByOffset(startTopPosition);
                        var startBottomOffset = startTopOffset + heightRows;

                        var endTopOffset = self.getTimeIndexByOffset(parseInt(ui.position.top));
                        var endBottomOffset = endTopOffset + heightRows;
                        var i;

                        if (endColumn.find('> div').selectable('option', 'disabled') == true) {
                            endColumnId = startColumnId;
                            endTopOffset = startTopOffset;
                            endBottomOffset = startBottomOffset;
                        } else {
                            for (i = endTopOffset; i < endBottomOffset; i++) {
                                if (options.workTime[endColumnId][i] == false) {
                                    endColumnId = startColumnId;
                                    endTopOffset = startTopOffset;
                                    endBottomOffset = startBottomOffset;
                                    break;
                                }
                            }
                        }

                        for (i = startTopOffset; i < startBottomOffset; i++) {
                            options.selectedTime[startColumnId][i] = false;
                        }

                        for (i = endTopOffset; i < endBottomOffset; i++) {
                            options.selectedTime[endColumnId][i] = true;
                        }

                        self._showSelectedTime();
                        self._callOnChangeTime();
                    }
                });
            }

            selectableTable.show();
            self._updateSelectableTime();
        },

        enableSortable : function() {
            var self = this;
            var options = self.options;

            var startTopPosition = 0;
            var endColumn = null;

            var sortableTable = self.element.find('.blocks-table-inner');
            sortableTable.find('.time-block-scheduled').css('cursor', 'move');
            self.element.find('.time-block-scheduled').caScheduleGridBlock('option', 'openByClick', false);

            sortableTable.find('.column-inner').sortable({
                connectWith : sortableTable.find('.column-inner'),
                grid : [options.columnWidth + 1, options.rowHeight],
                containment : sortableTable.parent(),
                items : '.time-block:has(.time-block-scheduled)',
                start : function(event, ui) {
                    startTopPosition = parseInt(ui.helper.css('top'));
                },
                beforeStop : function(event, ui) {
                    endColumn = $(ui.helper).closest('.column');
                },
                stop : function(event, ui) {
                    var heightRows = ui.item.height() / options.rowHeight;
                    var startColumn = $(this).closest('.column');
                    var endColumnInner = endColumn.find('.column-inner');

                    var startColumnId = self.getColumnIdByIndex(startColumn.index());
                    var endColumnId = self.getColumnIdByIndex(endColumn.index());
                    var block = $(ui.item);

                    var startTopOffset = self.getTimeIndexByOffset(startTopPosition);
                    var startBottomOffset = startTopOffset + heightRows;

                    var endTopOffset = self.getTimeIndexByOffset(parseInt(ui.position.top));
                    var endBottomOffset = endTopOffset + heightRows;

                    if (endTopOffset < 0) {
                        endTopOffset = 0;
                    }
                    if (self.getOffsetByTimeIndex(endBottomOffset) > endColumnInner.height()) {
                        endTopOffset = self.getTimeIndexByOffset(endColumnInner.height() - ui.item.height());
                    }

                    for (var i = endTopOffset; i < endBottomOffset; i++) {
                        if (options.workTime[endColumnId][i] == false) {
                            endColumnId = startColumnId;
                            endTopOffset = startTopOffset;
                            endBottomOffset = startBottomOffset;
                            break;
                        }
                    }

                    block.css('top', self.getOffsetByTimeIndex(endTopOffset) +'px');
                    block.css('left', 0);

                    var scheduleId = block.find('> div').caScheduleGridBlock('option', 'scheduleId');
                    var startTime = self.getTimeByRowIndex(endTopOffset);
                    var endTime = self.getTimeByRowIndex(endTopOffset + heightRows);
                    var columnData = self.getColumnDataByColumnId(endColumnId);
                    var resourceId = columnData.resourceId;
                    var date = columnData.date;
                    
                    if (isFinite(scheduleId)) {
                        $.caPost('/spa/save-schedule-position', {
                            scheduleId : scheduleId,
                            date : date,
                            startTime : startTime,
                            endTime : endTime,
                            resourceId : resourceId
                        }, function(response) {
                            if (response.status == 1) {
                                $('body').caSpaScheduleManager('updateSchedule');
                            } else {
                                $.caAlert(response.message);
                                block.css('top', self.getOffsetByTimeIndex(startTopOffset) +'px');
                                block.css('left', 0);
                                block.appendTo($(this));
                            }
                        }, 'json');
                    }
                }
            });

            sortableTable.find('.time-block-scheduled').parent().resizable({
                handles : 'n,s',
                grid : options.rowHeight,
                minHeight : options.rowHeight,
                stop : function(event, ui) {
                    var block = $(ui.element);
                    var top = parseInt(block.css('top'));
                    var height = block.height();
                    var columnId = self.getColumnIdByIndex($(this).closest('.column').index());

                    if (top < ui.originalPosition.top) {
                        var startIndex = self.getTimeIndexByOffset(ui.originalPosition.top);
                        var endIndex = self.getTimeIndexByOffset(top);

                        if (endIndex < 0) {
                            block.css('top', 0);
                            block.height(block.height() - Math.abs(endIndex) * options.rowHeight);
                            endIndex = 0;
                        }

                        for (var i = startIndex; i >= endIndex; i--) {
                            if (options.workTime[columnId][i] == false) {
                                startIndex = i + 1;
                                height -= (startIndex - endIndex) * options.rowHeight;
                                block.css('top', self.getOffsetByTimeIndex(startIndex));
                                block.height(height);
                                break;
                            }
                        }
                    } else if (height > ui.originalSize.height) {
                        var startIndex = self.getTimeIndexByOffset(top + ui.originalSize.height);
                        var endIndex = self.getTimeIndexByOffset(top + height);
                        var columnInnerHeight = block.closest('.column-inner').height();

                        if (columnInnerHeight < (top + height)) {
                            endIndex = self.getTimeIndexByOffset(columnInnerHeight);
                            block.height((endIndex - self.getTimeIndexByOffset(top)) * options.rowHeight);
                        }

                        for (var i = startIndex; i < endIndex; i++) {
                            if (options.workTime[columnId][i] == false) {
                                height -= (endIndex - i) * options.rowHeight;
                                block.height(height);
                                break;
                            }
                        }
                    }

                    top = parseInt(block.css('top'));
                    height = block.height();

                    var scheduleId = block.find('> div').caScheduleGridBlock('option', 'scheduleId');
                    var startTime = self.getTimeByRowIndex(self.getTimeIndexByOffset(top));
                    var endTime = self.getTimeByRowIndex(self.getTimeIndexByOffset(top + height));
                    var columnData = self.getColumnDataByColumnId(columnId);
                    var resourceId = columnData.resourceId;
                    var date = columnData.date;

                    if (isFinite(scheduleId)) {
                        $.caPost('/spa/save-schedule-position', {
                            scheduleId : scheduleId,
                            date : date,
                            startTime : startTime,
                            endTime : endTime,
                            resourceId : resourceId
                        }, function(response) {
                            if (response.status == 1) {
                                $('body').caSpaScheduleManager('updateSchedule');
                            } else {
                                $.caAlert(response.message);
                            }
                        }, 'json');
                    }
                }
            });
        },

        disableSortable : function() {
            var self = this;

            var sortableTable = self.element.find('.blocks-table-inner .column-inner');

            sortableTable.find('.time-block-scheduled').css('cursor', 'pointer');
            
            if (sortableTable.data('sortable') != undefined) {
                sortableTable.sortable('disable');
            }
            
            self.element.find('.time-block-scheduled').caScheduleGridBlock('option', 'openByClick', true);
        },

        disableSelectable : function() {
            this.element.find('.selectable-table').hide();
        },

        getTimeByRowIndex : function(rowIndex) {
            var self = this;

            var time = new Date(self.options.startTime.getTime());
            time.setTime(time.getTime() + rowIndex * self.options.timeInterval * 60000);

            var ante = 'AM';
            var hours = time.getHours();
            var minutes = time.getMinutes();

            if (hours >= 12) {
                ante = 'PM';
                if (hours > 12) {
                    hours -= 12;
                }
            }

            if (minutes < 10) {
                minutes = '0'+ minutes;
            }

            return hours + ':'+ minutes + ante;
        },

        getRowIndexByTime : function(time) {
            var self = this;

            var hours = parseInt(time.split(':')[0]);
            var minutes = parseInt(time.split(':')[1].replace(/AM|PM/, ''));

            if (time.indexOf('PM') !== -1) {
                if (hours !== 12) {
                    hours += 12;
                }
            }

            var rowTime = new Date();
            rowTime.setHours(hours);
            rowTime.setMinutes(minutes);
            rowTime.setSeconds(0);

            return parseInt((rowTime.getTime() - self.options.startTime.getTime()) / 60000 / self.options.timeInterval);
        },

        getSelectedTime : function(indexByKey) {
            var selectedTime = {};
            if (indexByKey == undefined) {
                indexByKey = 'resourceId';
            }

            var self = this;

            for (var columnId in self.options.selectedTime) {
                columnId = columnId;
                var startTime = null;
                var endTime = null;
                for (var rowIndex in self.options.selectedTime[columnId]) {
                    rowIndex = parseInt(rowIndex);
                    var isSelected = self.options.selectedTime[columnId][rowIndex];
                    if (isSelected) {
                        if (startTime == null) {
                            startTime = self.getTimeByRowIndex(rowIndex);
                        }
                        endTime = self.getTimeByRowIndex(rowIndex + 1);
                    } else {
                        if (startTime != null && endTime != null) {
                            var columnData = $.extend({}, self.getColumnDataByColumnId(columnId));
                            columnData.startTime = startTime;
                            columnData.endTime = endTime;

                            if (selectedTime[columnData[indexByKey]] == undefined) {
                                selectedTime[columnData[indexByKey]] = [];
                            }

                            selectedTime[columnData[indexByKey]].push(columnData);

                            startTime = null;
                            endTime = null;
                        }
                    }
                }
                if (startTime != null && endTime != null) {
                    var columnData = $.extend({}, self.getColumnDataByColumnId(columnId));
                    columnData.startTime = startTime;
                    columnData.endTime = endTime;

                    if (selectedTime[columnData[indexByKey]] == undefined) {
                        selectedTime[columnData[indexByKey]] = [];
                    }

                    selectedTime[columnData[indexByKey]].push(columnData);
                }
            }

            return selectedTime;
        },

        getAllColumnsData : function() {
            return this.options.columnsData;
        },

        getColumnDataByColumnId : function(columnId) {
            if (this.options.columnsData[columnId] != undefined) {
                return this.options.columnsData[columnId];
            }

            return null;
        },

        addSelectedBlock : function(columnId, startTime, endTime) {
            var self = this;
            var startRowIndex = self.getRowIndexByTime(startTime);
            var endRowIndex = self.getRowIndexByTime(endTime) - 1;

            if (!self.options.multiColumnSelectable) {
                var columnIndex = self.getColumnIndexById(columnId);
                self.element.find('.selectable-table .column > div').selectable('disable');
                self.element.find('.selectable-table .column:eq('+ columnIndex +') > div').selectable('enable');
            }

            if (self.options.selectedTime[columnId] != undefined) {
                for (var i = startRowIndex; i <= endRowIndex; i++) {
                    if (self.options.workTime[columnId][i] == true) {
                        self.options.selectedTime[columnId][i] = true;
                    }
                }
            }

            self._showSelectedTime();
        },

        removeSelectedBlock : function(columnId, startTime, endTime) {
            var self = this;
            var startRowIndex = self.getRowIndexByTime(startTime);
            var endRowIndex = self.getRowIndexByTime(endTime) - 1;

            for (var i = startRowIndex; i <= endRowIndex; i++) {
                self.options.selectedTime[columnId][i] = false;
            }

            self._showSelectedTime();
        },

        setSelectedTime : function(selectedTime) {
            var self = this;

            $.each(selectedTime, function(resourceId, selectedTimeData) {
                $.each(selectedTimeData, function(k, v) {
                    self.addSelectedBlock(v.columnId, v['startTime'], v['endTime'], v['data']);
                });
            });
        },

        addScheduledBlock : function(columnId, startTime, endTime, content, className) {
            var self = this;
            var startRowIndex = self.getRowIndexByTime(startTime);
            var endRowIndex = self.getRowIndexByTime(endTime);

            var column = self.element.find('#column-'+ columnId + ' .column-inner');

            var block = $('<div class="time-block"><div class="time-block-scheduled"></div></div>').appendTo(column);
            block.find('> div').append(content).addClass(className).addClass('time-block-scheduled-new');
            block.css('top', self.getOffsetByTimeIndex(startRowIndex));
            block.height((endRowIndex - startRowIndex) * this.options.rowHeight);
            block.width(this.options.columnWidth);
        },

        removeScheduledBlock : function(columnId, startTime, endTime) {
            var self = this;
            var startRowIndex = self.getRowIndexByTime(startTime);
            var endRowIndex = self.getRowIndexByTime(endTime);

            var column = self.element.find('#column-'+ columnId + ' .column-inner');
            var height = (endRowIndex - startRowIndex) * this.options.rowHeight;
            var top = self.getOffsetByTimeIndex(startRowIndex);

            $.each(column.find('.time-block-scheduled'), function(k, v) {
                var block = $(v).parent();
                if (block.height() == height && parseInt(block.css('top')) == top) {
                    block.remove();
                }
            });
        },

        clearScheduledBlocks : function() {
            var self = this;

            self.element.find('.blocks-table .time-block-scheduled-new').remove();
        },

        addHorizontalLongBlock : function(startTime, endTime, content) {
            var self = this;
            var startRowIndex = self.getRowIndexByTime(startTime);
            var endRowIndex = self.getRowIndexByTime(endTime);

            var column = self.element.find('.blocks-table .column-inner:eq(0)');
            var width = column.closest('.blocks-table').width();

            var longBlock = $('<div class="time-block"><div class="time-block-scheduled time-block-horizontal-long"></div></div>').appendTo(column);
            longBlock.css('z-index', 10);
            longBlock.find('> div').append(content);
            longBlock.css('top', self.getOffsetByTimeIndex(startRowIndex));
            longBlock.height((endRowIndex - startRowIndex) * this.options.rowHeight);
            longBlock.width(width);
        },

        removeHorizontalLongBlock : function(startTime, endTime) {
            var self = this;
            var startRowIndex = self.getRowIndexByTime(startTime);
            var endRowIndex = self.getRowIndexByTime(endTime);

            var column = self.element.find('.blocks-table .column-inner:eq(0)');
            var height = (endRowIndex - startRowIndex) * this.options.rowHeight;
            var top = self.getOffsetByTimeIndex(startRowIndex);

            $.each(column.find('.time-block-horizontal-long'), function(k, v) {
                var block = $(v).parent();
                if (block.height() == height && parseInt(block.css('top')) == top) {
                    block.remove();
                }
            });
        },

        clearHorizontalLongBlocks : function() {
            var self = this
            var column = self.element.find('.blocks-table .column-inner:eq(0)');
            column.find('.time-block-horizontal-long').remove();
        },

        getBlockByScheduleId : function(scheduleId) {
            var selector = '#schedule-block-'+ scheduleId;

            var block = $(selector);
            if (block.size() > 0) {
                return block;
            }

            return null;
        },

        disableAllColumns : function() {
            var self = this;

            $.each(self.element.find('.selectable-table .column'), function(k, v) {
                var column = $(v);
                if (column.find('.disabled-column').size() == 0) {
                    var disabledColumn = $('<div class="disabled-column"></div>').appendTo(column);
                    disabledColumn.height(self.element.height());
                }
            });
        },

        enableAllColumns : function() {
            this.element.find('.selectable-table .disabled-column').remove();
        },

        disableColumn : function(columnId) {
            var self = this;
            var columnIndex = self.getColumnIndexById(columnId);
            var tableHeight = self.element.height();
            var column = self.element.find('.selectable-table .column:eq('+ columnIndex +')');

            if (column.find('.disabled-column').size() == 0) {
                var disabledColumn = $('<div class="disabled-column"></div>').appendTo(column);
                disabledColumn.height(self.element.height());
            }
        },

        enableColumn : function(columnId) {
            var self = this;
            var columnIndex = self.getColumnIndexById(columnId);
            self.element.find('.selectable-table .column:eq('+ columnIndex +') .disabled-column').remove();
        },

        _callOnChangeTime : function() {
            this.options.onChangeTimeFunction.call(this.options.onChangeTimeThis);
        }
    });
})(jQuery);
